import fullpage from '../modules/fullPage';

export default () => {
  let $pageIndex = $('.page');
  let $mainSlider = $('.main-slider');


  $('.services__slide').hover(() => {
    $('.footer__info').css({pointerEvents: 'none', opacity: 0});
  }, () => {
      $('.footer__info').css({pointerEvents: 'auto', opacity: 1});
    }
  );

  $('.pages-navigation__arrow-next').click(() => {
    $.fn.fullpage.moveSlideRight();
  });

  $('.pages-navigation__arrow-left').click(() => {
    $.fn.fullpage.moveSlideLeft();
  });

  fullpage($mainSlider, {
    loopHorizontal: false,
    controlArrows: false,
    sectionSelector: '.main-slider__section',
    slideSelector: '.main-slider__slide',
    anchors: ['mainSection'],
    afterLoad: function (anchorLink, index) {
      const slides = $(this).find('.fp-slide');
      let total = slides.length;

      $('.pages-navigation__nums').text("01" + ' / ' + "0" + total++);

      $('.preloader').fadeOut(1000, function () {
        $(this).remove();
      });
    },
    afterSlideLoad: function (anchorLink, index, slideAnchor, slideIndex) {
      const loadedSlide = $(this);
      const totalItems = loadedSlide.siblings().length + 1;
      const current = slideIndex + 1;

      $('.pages-navigation__nums').text("0" + current + ' / ' + "0" + totalItems);
    },
    afterRender: function () {
      $(this).css({'background-size': 'cover'});
    },
    onSlideLeave: function (anchorLink, index, slideIndex, direction, nextSlideIndex) {
      let $slidesInfo = $('.menu__slide-info');

      $slidesInfo.eq(slideIndex).removeClass('menu__slide-info_active');
      $slidesInfo.eq(nextSlideIndex).addClass('menu__slide-info_active');

      if (nextSlideIndex > 1) {
        $pageIndex.addClass('page_black')
      } else {
        $pageIndex.removeClass('page_black')
      }

      if (nextSlideIndex > 3) {
        $pageIndex.addClass('page_hide-info');
      } else {
        $pageIndex.removeClass('page_hide-info');
      }
    }
  });

  if (window.innerWidth > 991) {
    // Scroll
    //Firefox
    $mainSlider.bind('DOMMouseScroll', function (e) {
      if (e.originalEvent.detail > 3) {
        //scroll down
        $
          .fn
          .fullpage
          .moveSlideRight();
      } else if (e.originalEvent.detail < -3) {
        //scroll up
        $
          .fn
          .fullpage
          .moveSlideLeft();
      }

      //prevent page fom scrolling
      return false;
    });

    //IE, Opera, Safari
    $mainSlider.bind('mousewheel', function (e) {
      if (e.originalEvent.wheelDelta < -20) {
        //scroll down
        $
          .fn
          .fullpage
          .moveSlideRight();
      } else if (e.originalEvent.wheelDelta > 20) {
        //scroll up
        $
          .fn
          .fullpage
          .moveSlideLeft();
      }

      //prevent page fom scrolling
      return false;
    });
  }

};



// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/main-slider.js